import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function ArrayTable(props: Props) {
    const [relayTitle, setRelayTitle] = useState('Relay');
    
    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            setRelayTitle('Relay ' + SNStatus[props.index].Relay.Name + ' ' + SNStatus[props.index].Relay.Time);
        } else {
            setRelayTitle('Relay');
        }
    }, [SNTime, props.index]);
    
    return (
        <div>
            <Table><TableBody>
                <TableRow style={{height:'7px'}}>
                    <TableCell colSpan={3} style={{paddingTop: 2, paddingBottom: 0, color: 'white', fontSize:'12px'}}>
                        {relayTitle}
                    </TableCell>
                </TableRow>
            </TableBody></Table>
        </div>
    )
}
